import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SUBMIT_SCENARIO } from "@/constants/testIds";

export function ViolentIncidentWarning({ onGoToBern }) {
  return (
    <div data-testid={SUBMIT_SCENARIO.violentWarning} className="p-5 rounded-sm bg-red-50 border border-red-200 space-y-3">
      <div className="flex items-center gap-2 text-red-700 font-bold uppercase text-sm">
        <AlertTriangle className="h-5 w-5" /> This isn't something to vote on
      </div>
      <p className="text-zinc-700 text-sm leading-relaxed">
        If you're describing a threatening or violent bias event, this needs an emergency response, not a
        vote. Go to BERN for live guidance, or check our During/After guidelines right now.
      </p>
      <Button type="button" onClick={onGoToBern} data-testid={SUBMIT_SCENARIO.goToBernButton} className="bg-red-600 hover:bg-red-700 text-white font-bold uppercase rounded-none w-full">
        Go to BERN Emergency Response
      </Button>
    </div>
  );
}
